import { IconProps, NocIconGenerator } from '../common';

export const Solo = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        css={{
            '& path': {
                strokeWidth: '1.2 !important',
            },
        }}
        createIconProps={{
            displayName: 'Solo',
            path: (
                <path
                    d="M15 11.79C14.29 10.26 12.43 9.57999 10.85 10.27C9.73 10.76 9 11.85 9 13.04V15.65H10.35L10.8 20H13.49L13.94 15.65H14.84M9.5 6C9.5 7.38 10.62 8.5 12 8.5C13.38 8.5 14.5 7.38 14.5 6C14.5 4.62 13.38 3.5 12 3.5C10.62 3.5 9.5 4.62 9.5 6Z"
                    stroke="#212121"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            ),
        }}
    />
);
